import { styled } from "@phntms/css-components";
import {marginVariants} from "../../style-variants";
import styles from "./styles.module.scss";

export const BreadCrumbContainer = styled('div',
  {
    css: [styles.breadcrumbContainer],
    variants: {
      ...marginVariants,
      center: {
        true: [styles.center]
      },
      small: {
        true: [styles.small]
      }
    }
  })

export const Root = styled('ol', {
  css: [styles.root]
})

export const RootItem = styled('li', {
  css: [styles.item]
});

